// extracted by mini-css-extract-plugin
export var base = "_2f-0";
export var updateBanner = "_2f-1";